import { render, staticRenderFns } from "./NewsSearch.vue?vue&type=template&id=ae5c0e6a&scoped=true"
import script from "./NewsSearch.vue?vue&type=script&lang=js"
export * from "./NewsSearch.vue?vue&type=script&lang=js"
import style0 from "./NewsSearch.vue?vue&type=style&index=0&id=ae5c0e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5c0e6a",
  null
  
)

export default component.exports